import { createAppKit } from '@reown/appkit/vue-core';
import { sepolia, mainnet, arbitrum, optimism, polygon, base } from 'viem/chains';

let initialized = false;
let hasProjectId = false;

export function initAppKit() {
  if (initialized) return;
  const projectId = (process.env.VUE_APP_WALLETCONNECT_PROJECT_ID as string) || '';
  hasProjectId = !!projectId;
  if (!hasProjectId) {
    console.warn('[AppKit] VUE_APP_WALLETCONNECT_PROJECT_ID is not set — AppKit disabled. Using injected wallets.');
    return; // Do not initialize AppKit without a project id to avoid APKT008 alerts
  }
  const brand = (process.env.VUE_APP_BRAND_NAME as string) || 'Flat 18 Demo';
  const appUrl = (process.env.APP_BASE_URL as string) || 'http://localhost:3000';
  let themeMode: 'dark' | 'light' = 'dark';
  try {
    const saved = localStorage.getItem('theme');
    if (saved === 'light' || saved === 'dark') themeMode = saved;
    else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) themeMode = 'dark';
    else themeMode = 'light';
  } catch {}

  createAppKit({
    projectId,
    networks: [sepolia, mainnet, arbitrum, optimism, polygon, base],
    defaultNetwork: sepolia,
    themeMode,
    metadata: {
      name: brand,
      description: 'DeFi Swapper',
      url: appUrl,
      icons: ['/assets/logo.svg']
    }
  });
  console.log('[AppKit] Initialized');
  (window as any).__APPKIT_READY__ = true;
  initialized = true;
}

export function appKitReady() {
  return (window as any).__APPKIT_READY__ === true || (initialized && hasProjectId);
}
